import React from "react";
import "./About.css";
import { NavLink } from "react-router-dom";

const About = () => {
  return (
    <div>
      <section className="about-section">
        <div className="container">
          <div className="row">
            <div className="content-column col-lg-6 col-md-12 col-sm-12 order-2">
              <div className="inner-column">
                <div className="sec-title">
                  <span className="title">About us</span>
                  <h2>We are Creative Tech Enthusiast working since 2019</h2>
                </div>
                <div className="text">
                  At ICOESS Solutions Pvt. Ltd., we are dedicated to delivering innovative software and web development solutions tailored to modern business needs. With a team of experienced professionals, we specialize in creating high-performance web applications, enterprise solutions, and custom software development. Our expertise spans across multiple domains, including e-commerce, education, and business automation, helping clients streamline their operations and enhance digital experiences.
                </div>
                <div className="text">
                  With a strong commitment to quality and customer satisfaction, ICOESS Solutions continues to push the boundaries of technology, ensuring businesses stay ahead in a rapidly evolving digital world.
                </div>

                <div className="btn-box">
                  <NavLink to="/contact" className="theme-btn btn-style-one">
                    Contact Us
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="content-column col-lg-6 col-md-12 col-sm-12 order-2">
              <div className="inner-column">
                <div className="sec-title">
                  <span className="title">Mission</span>
                  <h2></h2>
                </div>
                <div className="text">
                  Our mission at ICOESS Solutions Pvt. Ltd. is to empower businesses with cutting-edge technology and innovative solutions. We strive to:
                </div>
                <div className="text">
                  <ul>
                    <li>Develop high-quality, scalable, and secure software solutions.</li>
                    <li>Deliver cost-effective digital transformation strategies.</li>
                    <li>Foster long-term partnerships through trust, transparency, and excellence.</li>
                    <li>Continuously innovate to meet the ever-changing technological landscape.</li>
                  </ul>
                </div>
                <p className="text">
                  By blending creativity with technical expertise, we aim to drive business growth and help organizations achieve their digital transformation goals efficiently.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="content-column col-lg-6 col-md-12 col-sm-12 order-2">
              <div className="inner-column">
                <div className="sec-title">
                  <span className="title">Vision</span>
                  <h2></h2>
                </div>
                <div className="text">
                  At ICOESS Solutions Pvt. Ltd., our vision is to become a global frontrunner in delivering innovative, reliable, and scalable web technology and software development solutions. We strive to redefine digital experiences by empowering businesses through advanced technologies, staying ahead of the curve with industry trends. By embracing cutting-edge innovations such as artificial intelligence, blockchain, and cloud technologies, we aim to drive digital transformation and create sustainable solutions that unlock new possibilities for businesses worldwide.
                </div>
              </div>
            </div>
          </div>
          <div className="column">
            <div className="sec-title">
              <span className="title">Our Future Goal</span>
              <h2>We want to lead in innovation & Technology</h2>
            </div>
            <div className="text">As we look to the future, our strategic objectives are centered on continuous growth and technological excellence:</div>
            <div className="text">
              <ul>
                <li><strong>Adopting Emerging Technologies:</strong> Seamlessly integrating AI, machine learning, and blockchain into our solutions to create more intelligent, secure, and future-proof applications.</li>
                <li><strong>Expanding Our Global Presence:</strong> Extending our reach to businesses across the globe, offering them transformative digital solutions tailored to their needs.</li>
                <li><strong>Fostering a Culture of Innovation:</strong> Committing to ongoing research and development to push the boundaries of what’s possible and deliver state-of-the-art solutions.</li>
                <li><strong>Building Lasting Partnerships:</strong> Strengthening collaborations with key industry players to deliver tailored, impactful solutions that drive mutual success.</li>
                <li><strong>Elevating User Experience:</strong> Consistently refining our approach to ensure the highest levels of usability, accessibility, and customer satisfaction across all our solutions.</li>
              </ul>
            </div>
            <p className="text">By focusing on these objectives, we are dedicated to helping our clients achieve their digital transformation goals, optimize operations, and maintain a competitive edge in an increasingly digital world.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
